import { render } from "./UserProfileBanner.vue?vue&type=template&id=3747cc5e"
import script from "./UserProfileBanner.vue?vue&type=script&lang=js"
export * from "./UserProfileBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__